import { environment } from '../../../environments/environment';

export class SocialConfig {
  public static googleAppId = environment.googleAppId;
  public static facebookAppId = environment.facebookAppId;
}
